import { apiClient } from '../../../provider';
import geozonesSchema from './geozone-list.graphql';

export default {
  async fetch() {
    const res = await apiClient.query({
      query: geozonesSchema.load,
      fetchPolicy: 'no-cache'
    });
    return res.data?.objects;
  }
};
